import React from 'react';
import { Carousel } from 'react-bootstrap';

const MedicNucleus = () => {
    return (
        <div className="roadRiderzProject">
        <h1 className="projects-Header">Medic Nucleus</h1>
        <div className="row site-details-rrz">
          <div className="col-md-6 p-2">
          <p>* MedicNucleus is an organization with equal emphasis on leadership, technology,quality and passion.</p>
          <p>
            * Medic Nucleus team Provided free treatment for Autistic children
            and poor family.
          </p>

          <p>
            * Medic_Nucleus team move to workshop every month.
          </p>
          <p>* This is a Functional site and Site fully responsive for large and small device.</p>
          <p>
            * This Site has Authentication system like google signin, register
            for new user with firebase.
          </p>
          <p>
            * Using technologies are ReactJS, React BootsTrap, Firebase, Netlify and implement Authorization system
          </p>
          
          </div>
          <div className="col-md-6 p-2">
            <Carousel fade>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.postimg.cc/y84ShZQQ/Screenshot-47.png"
                  alt="First slide"
                />
                <Carousel.Caption>
                  {/* <h3>First slide label</h3>
                  <p>
                    Nulla vitae elit libero, a pharetra augue mollis interdum.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.postimg.cc/q7msG7CN/Screenshot-50.png"
                  alt="Second slide"
                />
  
                <Carousel.Caption>
                  {/* <h3>Second slide label</h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.postimg.cc/nV94vpVL/Screenshot-51.png"
                  alt="Third slide"
                />
  
                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.postimg.cc/mgmzv5Zq/Screenshot-49.png"
                  alt="Third slide"
                />
  
                <Carousel.Caption>
                  {/* <h3>Fourth slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </div>
        </div>
       <div className="siteInfo">
       <h3 className="seeLive">See Live: </h3>
       <span>
          {" "}
          <a
            className="liveSite"
            target="_blank"
            href="https://medic-nucleus.netlify.app/"
          >
            <b>LiveSite</b>
          </a>
        </span>
        <span>
          <a
            className="clientSide"
            target="_blank"
            href="https://github.com/Iasir-Arafat-riaz/Medical-Nucleus-SPA-useFirebase"
          >
            <b>ClientSideCode</b>
          </a>
        </span>
        {/* <span>
          <a className="serverSide" target="_blank" href="https://github.com/Iasir-Arafat-riaz/RoadRiderz-CustomX-NodeExpressServer-Heroku"><b>ServerSideCode</b></a>
        </span> */}
       </div>
      </div>
    );
};

export default MedicNucleus;